import { getStateByCode, getStateByUf } from './BrazilStatusMap.utils';

const STATUS_CATEGORIES = {
  VALIDADO: 'Realizada',
  INVALIDO: 'Realizada',
  OK: 'Realizada',
  FREEZER: 'Aguardando',
  'NA FILA': 'NaFila',
  COLETANDO: 'Coletando',
  PROCESSANDO: 'Processando'
};

const aggregateSnapshotCharts = (rows = [], stateCode = 'ALL') => {
  const selectedUf = getStateByCode(stateCode)?.uf;
  const statuses = {};
  const states = {};

  rows.forEach((row) => {
    const uf = row.estado;
    if (!getStateByUf(uf) || (stateCode !== 'ALL' && uf !== selectedUf)) return;
    const quantity = Number(row.quantidade || 0);
    states[uf] = (states[uf] || 0) + quantity;
    const category = STATUS_CATEGORIES[String(row.grupo || '').toUpperCase()];
    if (category) statuses[category] = (statuses[category] || 0) + quantity;
  });

  return { statuses, states };
};

export default aggregateSnapshotCharts;
